import { render, staticRenderFns } from "./TangledChart.component.vue?vue&type=template&id=2418d777&"
import script from "./TangledChart.component.vue?vue&type=script&lang=js&"
export * from "./TangledChart.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports